import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchReportSchemas } from 'api/reports';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';
import { ReportResource, ReportSchema } from 'types/domain';

const DEFAULT_SCHEMA: ReportSchema = {
    columns: [],
    graph: {},
};

const useTableSchema = (resource: ReportResource) => {
    const { accountId } = useCurrentAccount();

    return useSuspenseQuery({
        queryKey: accountQueryKeys.reportSchemaByResource(accountId, resource),
        queryFn: () => fetchReportSchemas(accountId),
        select: data => {
            const schema = data.find(schema => schema.resource === resource);

            return schema?.schema ?? DEFAULT_SCHEMA;
        },
    });
};

export { useTableSchema };
